import * as styles from '@app/components/Scroller/Scroller.css'
import clsx from 'clsx'
import React from 'react'

export const Scroller = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>((props, ref) => {
  return <div ref={ref} {...props} className={clsx(props.className, styles.scroller)} />
})
